
<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>推送消息</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="text-align: left">
          <div style="white-space: nowrap">
         标题 <el-input v-model="addData.title" :maxlength="20" placeholder="请输入标题" style="width: 95%;margin-left: 20px"></el-input></div>
          <div style="white-space: nowrap">
            内容  <el-input
            style="margin-top: 10px;width: 95%;margin-left: 20px"
            type="textarea"
            :rows="2"
            :maxlength="50"
            placeholder="请输入内容"
            v-model="addData.text">
          </el-input></div>
        </el-row>

        <el-row style="text-align: center;margin-top: 10px">
          <el-button type="primary" plain @click="submit()">提交</el-button>
        </el-row>

      </el-row>
    </el-row>

  </div>
</template>

<script>
  export default {
    name: "InfoPush",
    mounted() {
      if(!this.$store.state.login.in){
        this.$router.push({ name: "login", params: { userId: 123 }})
      }
      // this.getstart()
    },
    data() {
      return {
        addData:{
          title:'',
          text:''
        }
      }
    },
    computed:{
    },
    watch:{
    },
    methods: {
      getstart() {
        let thi = this
        thi.mySelect('reservationSuccessNG').then(function (data) {

        })
      },
      //提交新增
      submit(){
        this.mySubmit('send',this.addData)
      },

    }
  }
</script>

<style scoped>
  .admin-body{
    /*background-color: white;*/
    width: 100%;
  }
  .main{
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/page/user/InfoPush.vue